import "../App.css";
import "../general.css";
import "../queries.css";

import { useEffect,useState} from "react";
import ReactGA from "react-ga4";

import Term from "../assets/images/T.pdf"
import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";


function Terms() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/terms", title: "Terms and conditions page" });
  }, []);
  
  useFacebookPageView();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    console.log(windowWidth);
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  return (
    <>
      <Seo
        title="Terms and Conditions of The Rouse Co."
        description="Private Policy of The Rouse Co. and subsidiery"
        url="https://therouseco.com/terms"
        keywords={["Rouse, drink, rehydration, sex, F*** It, Private Policy"]}
        uploadDate="2025-07-09"
        includeVideoSchema={false}
      />

      <div style={{width:"100%", height:"100vh", overflow: "scroll", marginTop: "5.6rem"}}>
        <p>Unable to display PDF file. <a href={Term}>Download</a> instead.</p>
          <iframe src={Term} width={"100%"} height={"100%"}/>
      </div>
    </>
  );
};

export default Terms;
